module.exports = __webpack_public_path__ + "img/20.fcc28c3b.jpg";